import React from 'react'
import PropTypes from 'prop-types'
import FilterItem from './FilterItem'
import { Menu, MenuList, MenuLabel } from '../../../bulma'

/**
* Generic sidebar filter component for filters with just one option.
*/
class SingleFilter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      // Stores if the filter was changed.
      hasChanged: false,
    }

    this.onClickHandler = this.onClickHandler.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // If no longer loading, clear the `changedValue` so we no longer show
    // a loading indicator on that filter item.
    if (this.props.isLoading && !nextProps.isLoading) {
      this.setState({ hasChanged: false })
    }
  }

  /**
  * onClick callback wrapper for when a promotion is clicked. Wraps the onChange
  * callback to store the recent changes in state and pass in a label for analytics.
  *
  * @param value {boolean} sale filter is active or not
  */
  onClickHandler(value) {
    this.setState({ hasChanged: true })

    this.props.onChange(value, value ? 'Add' : 'Remove')
  }

  render() {
    const {
      children, title, value, activeValue, aggregations, onChange, getFallbackUrl, isLoading, className, ...rest
    } = this.props

    const isSelected = Boolean(value)

    if (!aggregations.count && !isSelected) return false

    const promoIsLoading = isLoading && this.state.hasChanged

    const classes = [
      className || '',
      'is-shadowless',
    ]

    return (
      <Menu {...rest} className={classes.join(' ')}>
        {title ? <MenuLabel>{title}</MenuLabel> : false}
        <MenuList>
          <FilterItem
            onClick={() => {
 this.onClickHandler(!value ? activeValue : null)
}}
            fallbackUrl={getFallbackUrl ? getFallbackUrl(!value ? activeValue : null) : null}
            allowMultiple
            count={aggregations.count}
            isDisabled={isLoading}
            isLoading={promoIsLoading}
            isSelected={isSelected}
          >
            {children}
          </FilterItem>
        </MenuList>
      </Menu>
    )
  }
}

SingleFilter.defaultProps = {
  aggregations: [],
  isLoading: false,
  activeValue: true,
}

SingleFilter.propTypes = {
  // Value to be set if the filter is active.
  activeValue: PropTypes.any,
  // Aggregations for this filter.
  aggregations: PropTypes.object,
  // Filters/products currently loading.
  isLoading: PropTypes.bool,
  // Callback for when the filter changes.
  onChange: PropTypes.func.isRequired,
  // Display title for this filter.
  title: PropTypes.string,
  // Current value for this filter.
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.array,
  ]),
}

export default SingleFilter
